<template>
  <div class="modal-sidebar">
    <div class="modal-sidebar__menus" @click="setCurrentTab('profil')">
      PROFIL
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('informasi')">
      INFORMASI
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('detailpo')">
      DETAIL PO
    </div>
    <div
      class="modal-sidebar__menus"
      @click="setCurrentTab('legaldoc')"
      v-if="$get($store, 'state.permissions.34.allow')"
    >
      LEGAL DOKUMEN
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('totalevent')">
      TOTAL EVENT
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('sio')">
      SIO
    </div>
    <!-- <div class="modal-sidebar__menus" @click="underConstruction()">
      SIO
    </div> -->
    <div class="modal-sidebar__menus" @click="setCurrentTab('k3l')">
      KINERJA K3L
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('kplh')">
      KINERJA KPLH
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('kinerjakontrak')">
      KINERJA KONTRAK
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('kinerjapo')">
      KINERJA PO
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    underConstruction() {
      this.$store.commit('SET_NOTIF', 'Maaf, Fitur sedang dalam pengembangan.')
    },
    setCurrentTab(tab) {
      if (tab == 'informasi') {
        this.$store.dispatch('editingStore/getVendorStatus', {
          id: this.$store.state.level1.vendorId,
          name: 'information_level_1',
        })
      }
      if (tab == 'legaldoc') {
        this.$store.dispatch('editingStore/getVendorStatus', {
          id: this.$store.state.level1.vendorId,
          name: 'legaldoc_level_1',
        })
      }
      if (tab == 'sio') {
        this.$store.dispatch('editingStore/getVendorStatus', {
          id: this.$store.state.level1.vendorId,
          name: 'sio_level_1',
        })
      }
      if (tab == 'k3l') {
        this.$store.dispatch('editingStore/getVendorStatus', {
          id: this.$store.state.level1.vendorId,
          name: 'k3l_level_1',
        })
      }
      if (tab == 'kplh') {
        this.$store.dispatch('editingStore/getVendorStatus', {
          id: this.$store.state.level1.vendorId,
          name: 'kplh_level_1',
        })
      }
      this.$store.dispatch('level1/setCurrentTab', tab)
    },
  },
}
</script>
